<template>
    <div id="preview-main">
        <div class="report">
            <!-- 封面 -->
            <div class="report-cover">
                <!-- 头 -->
                <Row>
                    <Col>
                        <img :src="ball" style="height: 600px;float: right;">
                    </Col>
                </Row>
                <!-- 中间 -->
                <div class="report-cover-main">
                    <div></div>
                    <div><span name="companyName">{{companyName}}</span></div>
                    <div>{{ $t('MCM.preview.reportTitleSuffix', { year: year, month: month }) }}</div>
                    <div>{{ $t('MCM.preview.ver') }}</div>
                </div>
                <!-- 尾部 -->
                <div class="report-cover-bottom">
                    <img :src="foot">
                </div>
            </div>
        </div>

        <div class="report">
            <!-- 目录 -->
            <div class="report-contents">
                <!-- 头 -->
                <Row>
                    <Col span="24">
                        <img :src="contentsPicture" style="width: 100%;">
                    </Col>
                </Row>
                <!-- 中间 -->
                <Row>
                    <Col span="24">
                        <div class="report-contents-right">
                            <!--标题 -->
                            <div class="report-contents-title" style="margin-top: 69px;">
                                <span class="report-contents-title-left">01</span>
                                <span class="report-contents-title-right">
                                    <div>{{ $t('MCM.preview.contentsWorkSummary') }}</div>
                                    <div>{{ $t('MCM.preview.contents11') }}</div>
                                    <div>
                                        <div>{{ $t('MCM.preview.contents111') }}</div>
                                        <div>{{ $t('MCM.preview.contents112') }}</div>
                                        <div>{{ $t('MCM.preview.contents113') }}</div>
                                    </div>
                                    <div>{{ $t('MCM.preview.contents12') }}</div>
                                </span>
                            </div>
                            <div class="report-contents-title">
                                <span class="report-contents-title-left">02</span>
                                <span class="report-contents-title-right">
                                    <div>{{ $t('MCM.preview.contentsInstanceOptimize') }}</div>
                                    <div>{{ $t('MCM.preview.contents21') }}</div>
                                    <div id="secondColumn">{{ $t('MCM.preview.contents22') }}</div>
                                    <div>{{ $t('MCM.preview.contents23') }}</div>
                                    <div id="thirdColumn">
                                        <div>{{ $t('MCM.preview.contents231') }}</div>
                                        <div>{{ $t('MCM.preview.contents232') }}</div>
                                    </div>
                                </span>
                            </div>
                            <div class="report-contents-title" style="min-height: 54px;">
                                <span class="report-contents-title-left">03</span>
                                <span class="report-contents-title-right">
                                    <div>{{ $t('MCM.preview.contentsOtherOptimize') }}</div>
                                </span>
                            </div>
                            <div class="report-contents-title" style="min-height: 54px;">
                                <span class="report-contents-title-left">04</span>
                                <span class="report-contents-title-right">
                                    <div>{{ $t('MCM.preview.contentsRIMatching') }}</div>
                                </span>
                            </div>
                            <div class="report-contents-title" style="min-height: 80px;">
                                <span class="report-contents-title-left">05</span>
                                <span class="report-contents-title-right">
                                    <div>{{ $t('MCM.preview.contentsOperation') }}</div>
                                    <div>{{ $t('MCM.preview.contents51') }}</div>
                                    <div id="contents-second">{{ $t('MCM.preview.contents52') }}</div>
                                </span>
                            </div>
                            <div class="report-contents-title">
                                <span class="report-contents-title-left">06</span>
                                <span class="report-contents-title-right">
                                    <div>{{ $t('MCM.preview.contentsMajorEvent') }}</div>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
                <!-- 尾 -->
                 <Row>
                    <Col>
                        <img :src="foot" style="height: 100px;width: 100%;">
                    </Col>
                </Row>
            </div>
        </div>

        <div class="report">
            <!-- 工作总结 -->
            <div class="summary">
                <div class="summary-bigTitle">{{ $t('MCM.preview.workSummaryTitle') }}</div>
                <!-- 1.1事件分析 -->
                <div class="summary-secondTitle">{{ $t('MCM.preview.eventAnalysis') }}</div>
                <!-- 1.1.1 事件处理 -->
                <div class="summary-thirdTitle">{{ $t('MCM.preview.eventHandling') }}</div>

                <!-- 事件总览 -->
                <div class="summary-event" id="eventOverview"></div>
                <div class="summary-first">{{ $t('MCM.preview.summaryFirst', { month: month, amount: amount, compareMonth: compareMonth, increasedReduction: increasedReduction, cmAmount: cmAmount }) }}</div>
                <div class="summary-second">{{ $t('MCM.preview.summarySecond', { month: month }) }}</div>
                <!-- 1.1.2月度告警分析 -->
                <div class="summary-thirdTitle">{{ $t('MCM.preview.monthlyAlarmAnalysis') }}</div>
                <div class="other-first">{{ $t('MCM.preview.warningText', { month: month, reviews: reviews }) }}</div>
                <div id="warning"></div>
                <!-- 1.1.3事件SLA分析 -->
                <div class="summary-thirdTitle">{{ $t('MCM.preview.eventSlaAnalysis') }}</div>
                <div class="summary-third">{{ $t('MCM.preview.responseTimeText', { time: responseTimeAvg }) }}</div>
                <div class="summary-time">
                    <div class="summary-time-title">{{ $t('MCM.preview.avgResponseTime') }}</div>
                    <div name="time">{{responseTimeAvg}}Min</div>
                </div>
                <div class="summary-third">{{ $t('MCM.preview.solutionTimeText', { time: solutionTimeAvg }) }}</div>
                  <div class="summary-time">
                    <div class="summary-time-title">{{ $t('MCM.preview.avgSolutionTime') }}</div>
                    <div name="time">{{solutionTimeAvg}}Min</div>
                  </div>
            </div>
        </div>

        <div class="report">
            <div class="accounting">
                <!-- 1.2月度账务分析 -->
                <div class="accounting-secondTitle" style="margin-top: 40px;">{{ $t('MCM.preview.monthlyAccountAnalysis') }}</div>
                <div class="accounting-first">{{ $t('MCM.preview.accountingFirst', { compareMonth: billRelativeMonthStr, fallingUp: billCompareResult, percentage: billCompareResultRatio, accountReason: billAnalysis }) }}</div>
                <div id="annualMonthlyExpenses"></div>
                <div class="accounting-second" style="margin-top: 60px;">{{ $t('MCM.preview.accountingSecond', { month: month, mainFocus: mainFocusService }) }}</div>
                <div style="width:100%;font-size: 13px;text-align: center;color: #424242;font-weight: 600;">{{ $t('MCM.preview.top5ServiceCost') }}</div>
                <div id="totalEvents" style="width: 210mm;height:300px;"></div>
                <div class="accounting-third">{{ $t('MCM.preview.accountingThird') }}</div>
            </div>
        </div>

        <div class="report">
            <div class="example">
                <!-- 实例优化建议 -->
                <div class="example-bigTitle">{{ $t('MCM.preview.instanceOptimizeTitle') }}</div>
                <!-- 2.1 EC2优化建议 -->
                <div class="accounting-secondTitle">{{ $t('MCM.preview.ec2OptimizeTitle') }}</div>
                <!-- 6月份EC2实例运行状况预览及优化建议 -->
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title">{{ $t('MCM.preview.ec2PreviewTitle', { month: month }) }}</div>
                    <table id="table-first" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{ $t('MCM.preview.instanceName') }}</th>
                                <th>{{ $t('MCM.preview.instanceType') }}</th>
                                <th>{{ $t('MCM.preview.cpuUtilizationRate') }}</th>
                                <th>{{ $t('MCM.preview.memoryUtilizationRate') }}</th>
                                <th>{{ $t('MCM.preview.optimizeSuggestion') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newEc2Suggest">
                                <td>{{item.resourceName}}</td>
                                <td>{{item.resourceType}}</td>
                                <td>{{item.cpuUtilization}}%</td>
                                <td>{{item.memoryUtilization}}%</td>
                                <td>{{item.optimizeSuggestion}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 优化建议 -->
                <div class="example-suggestion">
                    <div><span style="font-weight: 600;">{{ $t('MCM.preview.ec2SuggestionLabel') }}</span><span name="EC2suggestions">{{ec2OptimizeSuggestion}}</span></div>
                </div>

                <!-- 6月份RDS实例运行状况预览及优化建议 -->
                <!-- 2.2 RDS优化建议 -->
                <div class="accounting-secondTitle">{{ $t('MCM.preview.rdsOptimizeTitle') }}</div>
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title">{{ $t('MCM.preview.rdsPreviewTitle', { month: month }) }}</div>
                    <table id="table-second" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{ $t('MCM.preview.databaseName') }}</th>
                                <th>{{ $t('MCM.preview.databaseInstanceType') }}</th>
                                <th>{{ $t('MCM.preview.cpuUtilizationRate') }}</th>
                                <th>{{ $t('MCM.preview.freememory') }}</th>
                                <th>{{ $t('MCM.preview.freeDisk') }}</th>
                                <th>{{ $t('MCM.preview.optimizeSuggestion') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newRdsSuggest">
                                <td>{{item.resourceName}}</td>
                                <td>{{item.resourceType}}</td>
                                <td>{{item.cpuUtilization}}%</td>
                                <td>{{item.freememory}}MB</td>
                                <td>{{item.freeDisk}}GB</td>
                                <td>{{item.optimizeSuggestion}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 优化建议 -->
                <div class="example-suggestion">
                    <div><span style="font-weight: 600;">{{ $t('MCM.preview.rdsSuggestionLabel') }}</span><span name="RDSsuggestions">{{rdsOptimizeSuggestion}}</span></div>
                </div>

                <!-- 2.3 实例花费节省预览 -->
                <div class="accounting-secondTitle">{{ $t('MCM.preview.instanceCostSavePreview') }}</div>
                <div class="example-first">{{ $t('MCM.preview.exampleFirst', { saveMoney: saveMoney }) }}</div>

                <!-- 2.3.1 降级前后花费对比 -->
                <div style="font-size:15px;font-weight: 600;">{{ $t('MCM.preview.costComparisonTitle') }}</div>
                <!-- 实例（EC2和RDS）降级前后花费对比 -->
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title">{{ $t('MCM.preview.instanceCostComparison') }}</div>
                    <table id="table-third" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{ $t('MCM.preview.instanceName') }}</th>
                                <th>{{ $t('MCM.preview.optimizeType') }}</th>
                                <th>{{ $t('MCM.preview.resourceBefore') }}</th>
                                <th>{{ $t('MCM.preview.resourceAfter') }}</th>
                                <th>{{ $t('MCM.preview.unitPriceBefore') }}</th>
                                <th>{{ $t('MCM.preview.unitPriceAfter') }}</th>
                                <th>{{ $t('MCM.preview.saveCost') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in instanceRelegationCost">
                                <td>{{item.resourceName}}</td>
                                <td>{{item.optimizeType}}</td>
                                <td>{{item.resourceType}}</td>
                                <td>{{item.optimizeResourceType}}</td>
                                <td>{{item.unitPriceBefore}}</td>
                                <td>{{item.unitPriceAfter}}</td>
                                <td>{{item.saveCost}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 2.3.2 预留实例推荐花费对比 -->
                <div style="font-size:15px;font-weight: 600;">{{ $t('MCM.preview.riCostComparisonTitle') }}</div>
                <!-- 实例（EC2和RDS）购买预留实例前后花费对比 -->
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title">{{ $t('MCM.preview.instanceRiCostComparison') }}</div>
                    <table id="table-fourth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th v-show="costComparison">{{ $t('MCM.preview.accountId') }}</th>
                                <th v-show="costComparison">{{ $t('MCM.preview.accountName') }}</th>
                                <th v-show="isAccountGroupName">{{ $t('MCM.preview.accountGroupName') }}</th>
                                <th>{{ $t('MCM.preview.instanceTenancy') }}</th>
                                <th>{{ $t('MCM.preview.productDescription') }}</th>
                                <th>{{ $t('MCM.preview.instanceType') }}</th>
                                <th>{{ $t('MCM.preview.recommendBuyRI') }}</th>
                                <th>{{ $t('MCM.preview.onDemandCost') }}</th>
                                <th>{{ $t('MCM.preview.noUpfrontCost') }}</th>
                                <th>{{ $t('MCM.preview.partUpfrontCost') }}</th>
                                <th>{{ $t('MCM.preview.allUpfrontCost') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in riCost">
                                <td v-show="costComparison">{{item.accountIdString}}</td>
                                <td v-show="costComparison">{{item.accountName}}</td>
                                <td v-show="isAccountGroupName">{{item.accountGroupName}}</td>
                                <td>{{item.instanceTenancy}}</td>
                                <td>{{item.productDescription}}</td>
                                <td>{{item.instanceType}}</td>
                                <td>{{item.unmatchCount}}</td>
                                <td>{{item.onDemandCost}}</td>
                                <td>{{item.noUpfrontCost}}</td>
                                <td>{{item.partUpfrontCost}}</td>
                                <td>{{item.allUpfrontCost}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="report">
            <div class="other">
                <!-- 3 其他优化建议 -->
                <div class="example-bigTitle">{{ $t('MCM.preview.otherOptimizeTitle') }}</div>
                <div id="result"></div>

                <!-- 4 RI匹配情况 -->
                <div class="example-bigTitle">{{ $t('MCM.preview.riMatchingTitle') }}</div>
                <div class="other-first">{{ $t('MCM.preview.riMatchingText', { count: console }) }}</div>

                <div class="example-EC2">
                    <table id="table-fifth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th v-show="reservedInstance">{{ $t('MCM.preview.accountId') }}</th>
                                <th v-show="reservedInstance">{{ $t('MCM.preview.accountName') }}</th>
                                <th v-show="isReservedInstance">{{ $t('MCM.preview.accountGroupName') }}</th>
                                <th>{{ $t('MCM.preview.instanceTenancy') }}</th>
                                <th>{{ $t('MCM.preview.productDescription') }}</th>
                                <th>{{ $t('MCM.preview.instanceType') }}</th>
                                <th>{{ $t('MCM.preview.totalBuyRI') }}</th>
                                <th>{{ $t('MCM.preview.unmatchRI') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in riMatching">
                                <td v-show="reservedInstance">{{item.accountIdString}}</td>
                                <td v-show="reservedInstance">{{item.accountName}}</td>
                                <td v-show="isReservedInstance">{{item.accountGroupName}}</td>
                                <td>{{item.instanceTenancy}}</td>
                                <td>{{item.productDescription}}</td>
                                <td>{{item.instanceType}}</td>
                                <td>{{item.instanceCount}}</td>
                                <td>{{item.unmatchCount}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="report">
            <div class="important">
                <!-- 5 运维工作 -->
                <div class="important-bigTitle">{{ $t('MCM.preview.operationTitle') }}</div>
                <!-- 5.1 本月运维事件 -->
                <div class="important-secondTitle">{{ $t('MCM.preview.operationEventsTitle') }}</div>
                <div class="operationalEvent">
                    <table id="table-sixth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{ $t('MCM.preview.time') }}</th>
                                <th>{{ $t('MCM.preview.level') }}</th>
                                <th>{{ $t('MCM.preview.eventDescribe') }}</th>
                                <th>{{ $t('MCM.preview.eventProgress') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newOperationEvents">
                                <td>{{item.ticketTime}}</td>
                                <td>{{item.priorityId}}</td>
                                <td>{{item.ticketDescribe}}</td>
                                <td>{{item.ticketProgress}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="operationalEvent-first">{{ $t('MCM.preview.priorityNote') }}</div>

                <!-- 5.2 上月待处理事件 -->
                <div class="important-secondTitle">{{ $t('MCM.preview.eventsPendingTitle') }}</div>
                <div class="operationalEvent-first">{{ $t('MCM.preview.eventsPendingText') }}</div>
                <div class="operationalEvent">
                    <table id="table-seventh" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{ $t('MCM.preview.pendingEvent') }}</th>
                                <th>{{ $t('MCM.preview.belongType') }}</th>
                                <th>{{ $t('MCM.preview.problemReason') }}</th>
                                <th>{{ $t('MCM.preview.eventProgress') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newPendingEvents">
                                <td>{{item.ticketDescribe}}</td>
                                <td>{{item.ticketCategory}}</td>
                                <td>{{item.ticketReasons}}</td>
                                <td>{{item.ticketProgress}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="report">
            <div class="majorEvent">
                <!-- 6 重大事件 -->
                <div class="majorEvent-bigTitle">{{ $t('MCM.preview.majorEventTitle') }}</div>
                <div class="majorEvent-main" v-for="item in reportEventList">
                    <div class="majorEvent-title">{{ $t('MCM.preview.subjectLabel') }}{{item.eventTitle}}</div>
                    <div class="majorEvent-second">
                        <div>{{ $t('MCM.preview.problemDescribeLabel') }}</div>
                        <div>{{item.eventDescribe}}</div>
                    </div>
                    <div class="majorEvent-second">
                        <div>{{ $t('MCM.preview.eventProgressLabel') }}</div>
                        <div>{{item.eventProgress}}</div>
                    </div>
                    <div class="majorEvent-second">
                        <div>{{ $t('MCM.preview.eventResultLabel') }}</div>
                        <div>{{item.eventResult}}</div>
                    </div>
                </div>
                <!-- 备注一： -->
                <div class="operationalEvent-first" style="font-weight: 600;">{{ $t('MCM.preview.remarkOne') }}</div>
                <div class="operationalEvent-first">{{ $t('MCM.preview.eventPriorityPolicy') }}</div>
                <div class="operationalEvent">
                    <table id="table-eighth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{ $t('MCM.preview.claim') }}</th>
                                <th>{{ $t('MCM.preview.explanation') }}</th>
                                <th>{{ $t('MCM.preview.serviceIndicators') }}</th>
                                <th>{{ $t('MCM.preview.remarks') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in remark">
                                <td>{{item.claim}}</td>
                                <td>{{item.explanation}}</td>
                                <td>{{item.serviceIndicators}}</td>
                                <td>{{item.remarks}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    var previewVue = {}
    export default {
        name: 'Preview',
        props:['previewEditOldForm'],
        data(){
            return{
                reportEventList:[],
                newOperationEvents:[],
                newPendingEvents:[],
                newEc2Suggest:[],
                newRdsSuggest:[],
                reservedInstance:false,
                isReservedInstance:false,
                isAccountGroupName:false,
                costComparison:false,
                console:0,
                saveMoney:12,
                ec2OptimizeSuggestion:'',
                rdsOptimizeSuggestion:'',
                mainFocusService:'',
                billAnalysis:'',
                billRelativeMonthStr:'',
                billCompareResult:'',
                billCompareResultRatio:'',
                responseTimeAvg:0,
                solutionTimeAvg:0,
                reviews:'',
                amount:'',
                compareMonth:'',
                increasedReduction:'',
                cmAmount:'',
                year:'',
                month:'',
                companyName:'',//反参
                accountIdList:[],
                reportId:0,
                companyId:0,
                reportDate:'',  //初始化传参
                serviceNameList:[], //Top5服务花费
                top5ServiceCosts:[],
                totalEventsChart:'',
                allServiceTotalCost:'',
                annualMonthlyExpenditure:[], //年度每月花费
                xaxisData:[],
                chartAnnualMonthlyExpenses:'',
                xaxisAlerts:[], //警报分析
                alertAmounts:[],
                chartWarning:'',
                xaxisTicket:[], //事件总览
                p1Amounts:[],
                p2Amounts:[],
                p3Amounts:[],
                chartEventOverview:'', // echarts实例
                ball:require('../../../../../static/images/1.png'),
                foot:require('../../../../../static/images/2.png'),
                contentsPicture:require('../../../../../static/images/contentsPicture.png'), //封面图片
                ec2Suggest:[], //EC2优化建议
                rdsSuggest:[], //RDS优化建议
                instanceRelegationCost:[], //实例（EC2和RDS）降级前后花费对比
                riCost:[], //实例（EC2和RDS）购买预留实例前后花费对比
                riMatching:[], //RI匹配情况
                operationEvents:[], //本月运维事件
                pendingEvents:[], //上月待处理事件
                remark:[{
                    claim:this.$t('MCM.preview.remarkClaimP1'),
                    explanation:this.$t('MCM.preview.remarkExplanationP1'),
                    serviceIndicators:this.$t('MCM.preview.remarkServiceP1'),
                    remarks:this.$t('MCM.preview.remarkRemarksP1')
                },
                {
                    claim:this.$t('MCM.preview.remarkClaimP2'),
                    explanation:this.$t('MCM.preview.remarkExplanationP2'),
                    serviceIndicators:this.$t('MCM.preview.remarkServiceP2'),
                    remarks:this.$t('MCM.preview.remarkRemarksP2')
                },
                {
                    claim:this.$t('MCM.preview.remarkClaimP3'),
                    explanation:this.$t('MCM.preview.remarkExplanationP3'),
                    serviceIndicators:this.$t('MCM.preview.remarkServiceP3'),
                    remarks:this.$t('MCM.preview.remarkRemarksP3')
                },
                {
                    claim:this.$t('MCM.preview.remarkClaimP4'),
                    explanation:this.$t('MCM.preview.remarkExplanationP4'),
                    serviceIndicators:this.$t('MCM.preview.remarkServiceP4'),
                    remarks:this.$t('MCM.preview.remarkRemarksP4')
                }] //备注

            }
        },
        beforeCreate: function() {
            previewVue = this
        },
        mounted(){
            //自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartEventOverview.resize();
                self.chartAnnualMonthlyExpenses.resize();
                self.chartWarning.resize();
                self.totalEventsChart.resize();
            });
        },
        created(){
            this.$nextTick(function() {
                previewVue.eventOverviews();
                previewVue.annualMonthlyExpensess();
            });
        },
        methods:{
            /*************************************************************************/
            // 根据ID查询Report
            queryById:function(){
                this.$api.report.queryById("id",this.previewEditOldForm.id)
                .then(res => {
                    this.companyName=res.data.companyName;
                    this.year=res.data.year;
                    this.month=res.data.month;
                    // 月度账务分析原因
                    this.billAnalysis=res.data.billAnalysis;
                    // EC2优化建议
                    this.ec2OptimizeSuggestion=res.data.ec2OptimizeSuggestion;
                    // RDS优化建议
                    this.rdsOptimizeSuggestion=res.data.rdsOptimizeSuggestion;
                })
            },
            /*****************************重大事件********************************************/
            // 查询运维报告重大事件列表
            selectReportEventList:function(){
                this.$api.reportEvent.selectReportEventList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.reportEventList=res.data;
                })
            },
            /******************表格*******************************************************/
            // EC2优化建议&RDS优化建议
            selectReportOptimizeListInstance:function(){
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.newEc2Suggest=[];
                    this.newRdsSuggest=[];
                    this.ec2Suggest = res.data;
                    for(var i=0;i<this.ec2Suggest.length;i++){
                        if(this.ec2Suggest[i].type==0){
                            this.newEc2Suggest.push(this.ec2Suggest[i]);
                        }else if(this.ec2Suggest[i].type==1){
                            this.newRdsSuggest.push(this.ec2Suggest[i]);
                        }
                    }

                })
            },
            // 降级前后花费对比
            selectReportOptimizeListComparison:function(){
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.saveMoney=0;
                    this.instanceRelegationCost = res.data;
                    for(var i=0;i<this.instanceRelegationCost.length;i++){
                        // 优化类型
                        if(this.instanceRelegationCost[i].optimizeType==0){
                            this.instanceRelegationCost[i].optimizeType=this.$t('MCM.reportConfiguration.upgrade');
                        }else if(this.instanceRelegationCost[i].optimizeType==1){
                            this.instanceRelegationCost[i].optimizeType=this.$t('MCM.reportConfiguration.downgrade');
                        }

                        // 可节省花费
                        if(this.instanceRelegationCost[i].saveCost!=undefined){
                            this.saveMoney+=this.instanceRelegationCost[i].saveCost;
                        }
                    }
                })
            },
            // 预留实例推荐花费对比
            listReportReservedInstances:function(){
                this.$api.reportReservedInstance.listReportReservedInstances({
                    "reportId" : this.previewEditOldForm.id,
                    "reportReservedInstanceType" : 0
                })
                .then(res => {
                    this.riCost = res.data;
                    for(var i=0;i<this.riCost.length;i++){
                        // 租赁类型
                        if(this.riCost[i].instanceTenancy==0){
                            this.riCost[i].instanceTenancy='default';
                        }else if(this.riCost[i].instanceTenancy==1){
                            this.riCost[i].instanceTenancy='dedicated';
                        }else if(this.riCost[i].instanceTenancy==2){
                            this.riCost[i].instanceTenancy='host';
                        }

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.riCost[i].accountGroupName){
                            this.isAccountGroupName=true;
                            this.costComparison=false;
                        }else{
                            this.isAccountGroupName=false;
                            this.costComparison=true;
                        }
                    }
                })
            },
            // RI匹配情况
            listProdEnvironmentReservedInstance:function(){
                this.$api.reportReservedInstance.listReportReservedInstances({
                    "reportId" : this.previewEditOldForm.id,
                    "reportReservedInstanceType" : 1
                })
                .then(res => {
                    this.console=0;
                    this.riMatching = res.data;
                    for(var i=0;i<this.riMatching.length;i++){
                        // 租赁类型
                        if(this.riMatching[i].instanceTenancy==0){
                            this.riMatching[i].instanceTenancy='default';
                        }else if(this.riMatching[i].instanceTenancy==1){
                            this.riMatching[i].instanceTenancy='dedicated';
                        }else if(this.riMatching[i].instanceTenancy==2){
                            this.riMatching[i].instanceTenancy='host';
                        }

                        // 总共购买数量
                        this.console+=this.riMatching[i].instanceCount;

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.riMatching[i].accountGroupName){
                            this.isReservedInstance=true;
                            this.reservedInstance=false;
                        }else{
                            this.isReservedInstance=false;
                            this.reservedInstance=true;
                        }
                    }
                })
            },
            // 本月运维事件
            selectOperationEvents:function(){
                this.$api.reportTicket.selectReportTicketList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.newOperationEvents=[];
                    this.operationEvents = res.data;
                    for(var i=0;i<this.operationEvents.length;i++){
                        // 级别
                        if(this.operationEvents[i].priorityId==0){
                            this.operationEvents[i].priorityId='P1';
                        }else if(this.operationEvents[i].priorityId==1){
                            this.operationEvents[i].priorityId='P2';
                        }else if(this.operationEvents[i].priorityId==2){
                            this.operationEvents[i].priorityId='P3';
                        }else if(this.operationEvents[i].priorityId==3){
                            this.operationEvents[i].priorityId='P4';
                        }

                        if(this.operationEvents[i].type==0){
                            this.newOperationEvents.push(this.operationEvents[i]);
                        }
                    }
                })
            },
            // 上月待处理事件
            selectEventsPending:function(){
                this.$api.reportTicket.selectReportTicketList({
                    "reportId":this.previewEditOldForm.id
                })
                .then(res => {
                    this.newPendingEvents=[];
                    this.pendingEvents = res.data;
                    for(var i=0;i<this.pendingEvents.length;i++){
                        // 所属类型
                        if(this.pendingEvents[i].ticketCategory==0){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat0');
                        }else if(this.pendingEvents[i].ticketCategory==1){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat1');
                        }else if(this.pendingEvents[i].ticketCategory==2){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat2');
                        }else if(this.pendingEvents[i].ticketCategory==4){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat4');
                        }else if(this.pendingEvents[i].ticketCategory==5){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat5');
                        }else if(this.pendingEvents[i].ticketCategory==6){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat6');
                        }else if(this.pendingEvents[i].ticketCategory==7){
                            this.pendingEvents[i].ticketCategory=this.$t('MCM.reportConfiguration.ticketCat7');
                        }

                        if(this.pendingEvents[i].type==1){
                            this.newPendingEvents.push(this.pendingEvents[i]);
                        }
                    }
                })
            },

            /******************图表*******************************************************/
            init:function(){
                this.$nextTick(function() {
                    previewVue.eventOverviewLine();
                    previewVue.annualMonthlyExpensesLine();
                    previewVue.warningLine();
                    previewVue.totalEventsLine();
                });
            },
            /******************事件总览************************/
            eventOverviews:function(){
                if(this.previewEditOldForm.id==undefined){
                    return;
                }
                this.$api.reportTicket.selectPreviewByReportTicket({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    // 警报分析
                    this.reviews=res.data.reviews;
                    this.xaxisAlerts=res.data.xaxisAlert;
                    this.alertAmounts=res.data.alertAmounts;
                    // 事件总览
                    this.xaxisTicket=res.data.xaxisTicket;
                    this.p1Amounts=res.data.p1Amounts;
                    this.p2Amounts=res.data.p2Amounts;
                    this.p3Amounts=res.data.p3Amounts;
                    this.amount=res.data.amount;
                    this.compareMonth=res.data.compareMonth;
                    this.increasedReduction=res.data.increasedReduction;
                    this.cmAmount=res.data.cmAmount;
                    this.responseTimeAvg=Number(res.data.responseTimeAvg).toFixed(2);
                    this.solutionTimeAvg=Number(res.data.solutionTimeAvg).toFixed(2);
                    this.init();
                })
            },
            // 事件总览
            eventOverviewLine:function(){
                this.chartEventOverview=this.$echarts.init(document.getElementById("eventOverview"));
                this.chartEventOverview.setOption({
                    title: {
                        text: this.$t('MCM.preview.eventOverview'),
                        x: 'center',
                        textStyle:{
                            fontSize:13//主题文字字体大小，默认为18px
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        bottom: 0,
                        data: ['P1', 'P2', 'P3']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '9%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.xaxisTicket
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: 'P1',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            data: this.p1Amounts
                        },

                        {
                            name: 'P2',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            data: this.p2Amounts
                        },
                        {
                            name: 'P3',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            data: this.p3Amounts
                        }
                    ]
                })
            },
            /******************警报分析************************/
            // 警报分析
            warningLine:function(){
                this.chartWarning=this.$echarts.init(document.getElementById("warning"));
                this.chartWarning.setOption({
                    title: {
                        text: this.$t('MCM.preview.alertAnalysis'),
                        x: 'center',
                        textStyle:{
                            fontSize:13//主题文字字体大小，默认为18px
                        }
                    },
                    tooltip: {},
                    legend: {
                        bottom: 0,
                        data: [this.$t('MCM.preview.alarm')]
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '9%',
                        containLabel: true,
                        y2: 140
                    },
                    xAxis: {
                        data: this.xaxisAlerts
                    },
                    yAxis: {
                        min: 0,
                        max: 20
                    },
                    series: [{
                        name: this.$t('MCM.preview.alarm'),
                        type: 'bar',
                        barWidth: '40%',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        data: this.alertAmounts
                    }]
                })
            },
            /******************年度每月花费************************/
            annualMonthlyExpensess:function(){
                if(this.previewEditOldForm.id==undefined){
                    return;
                }
                this.$api.reportReservedInstance.getMonthlyBillingAnalysis({
                    "accountPrimaryKeyIds": this.previewEditOldForm.accountIdList,
                    "reportId" : this.previewEditOldForm.id,
                    "companyId" : this.previewEditOldForm.companyId,
                    "monthStr" : this.previewEditOldForm.reportDate
                })
                .then(res => {
                    // 相对月份
                    this.billRelativeMonthStr=res.data.billRelativeMonthStr;
                    // 花费上升下降
                    this.billCompareResult=res.data.billCompareResult;
                    if(this.billCompareResult==0){
                        this.billCompareResult=this.$t('MCM.reportConfiguration.fallingUp0');
                    }else if(this.billCompareResult==1){
                        this.billCompareResult=this.$t('MCM.reportConfiguration.fallingUp1');
                    }
                    // 上升下降比率
                    this.billCompareResultRatio=res.data.billCompareResultRatio;
                    // 年度每月花费
                    this.annualMonthlyExpenditure=res.data.annualMonthlyExpenditure;
                    this.xaxisData=res.data.xaxisData;

                    /**************************Top5服务花费*******************/
                    // 主要花费服务
                    this.mainFocusService=res.data.mainFocusService;
                    this.allServiceTotalCost=res.data.allServiceTotalCost;
                    this.serviceNameList=res.data.serviceNameList;
                    this.top5ServiceCosts=res.data.top5ServiceCosts;
                    this.init();
                })
            },
            // 年度每月花费
            annualMonthlyExpensesLine:function(){
                this.chartAnnualMonthlyExpenses=this.$echarts.init(document.getElementById("annualMonthlyExpenses"));
                this.chartAnnualMonthlyExpenses.setOption({
                    title: {
                        text: this.$t('MCM.reportConfiguration.annualMonthlyExpenses'),
                        x: 'center',
                        textStyle:{
                            fontSize:13//主题文字字体大小，默认为18px
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        bottom: 0,
                        data: [this.$t('MCM.reportConfiguration.monthlyExpenses')]
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '9%',
                        containLabel: true,
                        y2: 140
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: this.xaxisData,
                            axisLabel: {
                                interval: 0,
                                rotate: 40
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                        }
                    ],
                    series: [

                        {
                            name: this.$t('MCM.reportConfiguration.monthlyExpenses'),
                            type: 'line',
                            stack: '总量',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            areaStyle: { normal: {} },
                            data: this.annualMonthlyExpenditure
                        }
                    ]
                })
            },
            /******************Top5服务花费************************/
            // Top5服务花费
            totalEventsLine:function(){
                this.totalEventsChart=this.$echarts.init(document.getElementById("totalEvents"));
                this.totalEventsChart.setOption({
                    title: {
                        text: '￥'+this.allServiceTotalCost,
                        x: 'center',
                        y: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)',
                        confine: true
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: this.serviceNameList
                    },
                    series: [
                        {
                            type: 'pie',
                            center: ['50%', '50%'],
                            radius: ['55%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: true
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '12',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: true
                            },
                            data:this.top5ServiceCosts
                        }
                    ]
                });
            }
        }
    }
</script>

<style scoped>
    #preview-main{
        width: 210mm;
        margin: 0 auto;
        padding: 10mm;
    }
    .report
    {
        width: 210mm;
        margin: auto;
    }
    /*封面*/
    .report-cover
    {
        width: 210mm;
    }
    .report-cover-bottom
    {
        width: 210mm;
        overflow: hidden;
        height: 301px;
    }
    .report-cover-bottom>img
    {
        width: 210mm;
        height: 268px;
    }
    .report-cover-main
    {
        width: 90%;
        height: 615px;
        margin: auto;
    }
    .report-cover-main>div:nth-child(1)
    {
        font-size: 175px;
        height: 208px;
    }
    .report-cover-main>div:nth-child(2)
    {
        font-size: 35px;
        height: 54px;
    }
    .report-cover-main>div:nth-child(3)
    {
        font-size: 24px;
        min-height: 58px;
    }
    .report-cover-main>div:nth-child(4)
    {
        font-size: 19px;
        height: 55px;
    }
    .report-cover-main>div:nth-child(5)
    {
        font-size: 14px;
    }

    /*目录*/
    .report-contents
    {
        width: 210mm;
        overflow: hidden;
    }
    .report-img-second
    {
        width: 26%;
        height: 93%;
        display: block;
        margin-top: -160px;
        margin-left: 67px;
    }
    .report-contents-right
    {
        width: 80%;
        margin: auto;
    }
    .report-contents-title
    {
        width: 210mm;
        margin-bottom: 36px;
        min-height: 114px;
    }
    .report-contents-title-left
    {
        float: left;
        width: 75px;
        height: 45px;
        text-align: center;
        font-size: 45px;
        margin-right: 31px;
    }
    .report-contents-title-right
    {
        float: left;
    }
    .report-contents-title-right>div:nth-child(1)
    {
        font-size: 20px;
    }
    .report-contents-title-right>div:nth-child(2)
    {
        font-size: 14px;
    }
    .report-contents-title-right>div:nth-child(3)
    {
        font-size: 13px;
        margin-left: 20px;
    }
    .report-contents-title-right>div:nth-child(4)
    {
        font-size: 14px;
    }
    .report-contents-bottom
    {
        width: 210mm;
        overflow: hidden;
        height: 301px;

    }
    .report-contents-bottom>img
    {
        width: 210mm;
        height: 268px;
    }
    #contents-second
    {
        margin-left: 0;
    }

    /*工作总结*/
    .summary
    {
        width: 210mm;
        min-height: 1046px;
    }
    .summary-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
    }
    .summary-secondTitle
    {
        font-size: 16px;
    }
    .summary-thirdTitle
    {
        font-size: 15px;
        font-weight: 600;
    }
    .summary-event
    {
        width: 210mm;
        height: 480px;
    }
    .summary-first
    {
        font-size: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .summary-second
    {
        font-size: 14px;
        margin-bottom: 10px;
    }
    .summary-third
    {
        font-size: 14px;
        margin-top: 10px;
    }
    .summary-time
    {
        border-radius: 5px;
        margin-top: 17px;
        width: 210mm;
        height: auto;
        border: 1px solid #e2e2e2;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
    }
    .summary-time-title
    {
        width: 210mm;
        height: 40px;
        line-height: 40px;
        padding-left: 9px;
        box-sizing: border-box;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid #eaeaea;
    }
    .summary-time>div:nth-child(2)
    {
        height: 300px;
        line-height: 264px;
        text-align: center;
        font-size: 60px;
    }

    /*1.2 月度账务分析*/
    .accounting
    {
        width: 210mm;
        min-height: 898px;
    }
    .accounting-first
    {
        font-size: 14px;
        margin-bottom: 10px;
    }
    .accounting-second
    {
        font-size: 14px;
        margin-bottom: 25px;
    }
    .accounting-third
    {
        font-size: 14px;
    }
    .accounting-secondTitle
    {
        font-size: 16px;
        margin-bottom: 10px;
        margin-top: 14px;
    }
    #annualMonthlyExpenses
    {
        width: 210mm;
        height: 480px;
        margin-bottom: 25px;
    }

    /*2 实例优化建议*/
    .example
    {
        width: 210mm;
        min-height: 814px;
    }
    .example-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
    }
    .example-EC2
    {
        width: 210mm;
        height: auto;
        margin-bottom: 25px;
    }
    .example-EC2-title
    {
        width: 210mm;
        height: 40px;
        text-align: center;
        line-height: 27px;
        font-size: 14px;
    }
    .example-suggestion
    {
        width: 210mm;
        height: auto;
        /* background-color: red; */
        border: 1px solid #eae3e3;
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 20px;
    }
    .example-first
    {
        margin-bottom: 13px;
        font-size: 14px;
    }
    .report table
    {
        width: 210mm;
        height: auto;
        border-radius: 5px;
        border: 1px solid #eae8e8;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
    }

    /*其他优化建议*/
    .other
    {
        width: 210mm;
        min-height:100px;
    }
    .other-first
    {
        font-size: 14px;
        margin-bottom: 15px;
    }
    #warning
    {
        width: 210mm;
        height:480px;
    }
    /*运维工作*/
    .important
    {
        width: 210mm;
        min-height:100px;
    }
    .important-main
    {
        width: 210mm;
        height: auto;
        border: 1px solid #eae8e8;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
        margin-bottom: 10px;
    }
    .important-main-title
    {
        width: 210mm;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 9px;
        border-bottom: 1px solid #ccc;
        font-weight: 600;
    }
    .important-main-first
    {
        width: 97%;
        height: auto;
        border-bottom: 1px solid #ccc;
        font-size: 14px;
        padding: 10px;
    }
    .important-main-first>span:first-child
    {
        display: block;
        width: 210mm;
        font-weight: 600;
        height: 27px;
    }
    .important-main-second
    {
        width: 97%;
        height: auto;
        font-size: 14px;
        padding: 10px;
    }
    .important-main-second>span:first-child
    {
        display: block;
        width: 210mm;
        font-weight: 600;
        height: 27px;
    }
    .important-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
        overflow: hidden;
    }
    .important-secondTitle
    {
        font-size: 16px;
        margin-bottom: 10px;
    }
    .operationalEvent
    {
        width: 210mm;
        height: auto;
    }
    .operationalEvent-first
    {
        font-size: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    /*重大事件*/
    .majorEvent
    {
        width: 210mm;
        min-height:100px;
        margin-top: 20px;
    }
    .majorEvent-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
        overflow: hidden;
    }
    .majorEvent-main{
        width: 210mm;
        border:1px solid #dfe1e5;
        margin-bottom: 20px;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
    }
    .majorEvent-title{
        height: 46px;
        border-bottom: 1px solid #dfe1e5;
        padding: 10px;
        font-size: 13px;
        font-weight: 600;
    }
    .majorEvent-second{
        min-height: 46px;
        border-bottom: 1px solid #dfe1e5;
        padding: 10px;
        font-size: 13px;
    }
    .majorEvent-second>div:nth-child(1){
        font-weight: 600;
        font-size: 13px;
    }
    /*目录*/
    #secondColumn
    {
        font-size:14px;
        margin-left: 0px;
    }
    #thirdColumn>div
    {
        font-size: 13px;
        margin-left: 20px;
    }
    #table-first
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-first th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-first td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-second
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-second th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-second td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-third
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-third th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-third td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-fourth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-fourth th
    {
        height: 40px;
        white-space: normal;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-fourth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-fifth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-fifth th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-fifth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-sixth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-sixth th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-sixth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-seventh
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-seventh th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-seventh td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-eighth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-eighth th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-eighth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/Preview.vue